import React, { Component } from 'react';
import { Container } from 'react-grid-system';
import { connect } from 'react-redux';
import { RouteProps, withRouter } from 'react-router-dom';
import store from '../../store';
import Products from '../products/products';
import './search-page.scss';

interface SearchProps {
  products: any,
  match: any,
  history: any,
  location: any
}

interface SearchState {
}

const mapStateToProps = (state: any) => {
  return {
    products: state.products?.filter((p: any) => p.active && p.brandActive && p.categoryActive)
  }
}

class SearchPage extends Component<SearchProps & RouteProps, SearchState> {

  componentDidMount() {
    setTimeout(() => {
      window.scrollTo(0, 0)
      store.dispatch({ type: 'REFRESH_PRODUCTS' })
    });
  }

  render() {
    return (
      <div className="page search-page">
        <Container fluid={true} className="search-page-container" id="page-container">
          <Products
            products={this.props.products}
            locationSearch={this.props.location?.search || ""}
            infiniteScroll={this.props.location?.pathname === '/search'}
          ></Products>
        </Container>
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps)(SearchPage as any) as any);